import React from "react"
import { graphql } from "gatsby"
import Layout from "components/Layout/Layout"
import FeaturedLayout from "components/FeaturedLayout/FeaturedLayout"

const NewsArticleTemplate = (props) =>  {
	const data = props.data.wpNewsArticle
	return (
		<Layout 
			path={data.uri} 
			seo={data.seo} 
		>
			<FeaturedLayout data={data} type="News" uri={data.uri} />
		</Layout>
	)
}

export const newsArticleQuery = graphql`
query($id: String!) {
	wpNewsArticle(id: {eq: $id}) {
		id
		title
		uri
		date(formatString: "MMMM DD, Y")
		seo {
			metaKeywords
			metaDesc
			title
			breadcrumbs {
				text
				url
			}
		}
		...newsArticleTemplateQuery
	}
}
`

export default NewsArticleTemplate